import { BannerTypes } from 'components/page-flag/types'
import { FuelPricelistUrls } from 'types/customer'
import {
  IdentificationMethod,
  OptInCta,
  Product,
  SignChannel,
  SimulationSalesOffice,
  SimulationType,
  SourceType
} from '@boltenergy-be/shared'
import { AvailableProducts } from 'types/parameters'

export enum MarketingDataKeys {
  ADJUSTABLE_PRODUCT = 'adjustableProduct',
  AGENT_ID = 'agentID',
  IDENTIFICATION_METHOD = 'identificationMethod',
  AVAILABLE_PRODUCTS = 'availableProducts',
  BANNER = 'banner',
  BANNER_TYPE = 'bannerType',
  CALL_CAMPAIGN = 'callCampaign',
  CALL_PARTNER_ACCOUNT = 'callPartnerAccount',
  CAMPAIGN_NAME = 'campaignName',
  CREDIT_CHECK_CONFIRMATION_FLOW = 'creditCheckConfirmationFlow',
  CONFIRMATION_FROM_PORTAL_REGISTRATION = 'confirmationFromPortalRegistration',
  EAN_CODE_MANDATORY = 'eanCodeMandatory',
  EMAIL_CONFIRMATION_FLOW = 'emailConfirmationFlow',
  EVENT_ID = 'eventID',
  EVENT_NAME = 'eventName',
  EXECUTE_CREDIT_CHECK = 'executeCreditCheck',
  FETCH_SIMULATION_FLOW = 'fetchSimulationFlow',
  GCLID = 'gclid',
  NO_EAN_FLOW = 'noEanFlow',
  NO_OPTIN_ONE = 'noOptinOne',
  OPTIN_CTA = 'optinCta',
  PARTNER_ID = 'partnerID',
  PLENTY_OPPORTUNITY_ID = 'plentyOpportunityId',
  PREVIOUS_SUPPLIER = 'previousSupplier',
  PRICELIST_URLS = 'pricelistUrls',
  RESET_BUTTON = 'resetButton',
  SALESFORCE_USER_ALIAS = 'sfUserAlias',
  SIGN_CHANNEL = 'signChannel',
  SIMULATION_SO = 'simulationSo',
  SIMULATION_TYPE = 'simulationType',
  SKIP_ITSME = 'skipItsme',
  SOURCE_TYPE = 'sourceType',
  TRIGGER_EVENTS = 'triggerEvents',
  DYNAMIC_TARIFF_DEFAULT_CHECKED = 'dynamicTariffDefaultChecked',
  SETTLEMENT_FREQUENCY_MONTHLY_BY_DEFAULT = 'settlementFrequencyMonthlyByDefault'
}

export type MarketingStore = {
  [MarketingDataKeys.ADJUSTABLE_PRODUCT]: boolean
  [MarketingDataKeys.AVAILABLE_PRODUCTS]?: AvailableProducts
  [MarketingDataKeys.IDENTIFICATION_METHOD]?: IdentificationMethod
  [MarketingDataKeys.AGENT_ID]?: string
  [MarketingDataKeys.BANNER]?: string
  [MarketingDataKeys.BANNER_TYPE]?: BannerTypes
  [MarketingDataKeys.CALL_CAMPAIGN]?: string
  [MarketingDataKeys.CALL_PARTNER_ACCOUNT]?: string
  [MarketingDataKeys.CAMPAIGN_NAME]?: string
  [MarketingDataKeys.CREDIT_CHECK_CONFIRMATION_FLOW]: boolean
  [MarketingDataKeys.CONFIRMATION_FROM_PORTAL_REGISTRATION]: boolean
  [MarketingDataKeys.EAN_CODE_MANDATORY]: boolean
  [MarketingDataKeys.EMAIL_CONFIRMATION_FLOW]: boolean
  [MarketingDataKeys.EVENT_ID]?: string
  [MarketingDataKeys.EVENT_NAME]?: string
  [MarketingDataKeys.EXECUTE_CREDIT_CHECK]: boolean
  [MarketingDataKeys.FETCH_SIMULATION_FLOW]: boolean
  [MarketingDataKeys.GCLID]: string | null
  [MarketingDataKeys.NO_EAN_FLOW]: boolean
  [MarketingDataKeys.NO_OPTIN_ONE]: boolean
  [MarketingDataKeys.OPTIN_CTA]: OptInCta
  [MarketingDataKeys.PARTNER_ID]?: string
  [MarketingDataKeys.PLENTY_OPPORTUNITY_ID]?: string
  [MarketingDataKeys.PREVIOUS_SUPPLIER]: boolean
  [MarketingDataKeys.PRICELIST_URLS]?: FuelPricelistUrls
  [MarketingDataKeys.RESET_BUTTON]: boolean
  [MarketingDataKeys.SALESFORCE_USER_ALIAS]?: string
  [MarketingDataKeys.SIGN_CHANNEL]: SignChannel[]
  [MarketingDataKeys.SIMULATION_SO]?: SimulationSalesOffice | string
  [MarketingDataKeys.SIMULATION_TYPE]: SimulationType[]
  [MarketingDataKeys.SKIP_ITSME]: boolean
  [MarketingDataKeys.SOURCE_TYPE]: SourceType
  [MarketingDataKeys.TRIGGER_EVENTS]: string
  [MarketingDataKeys.DYNAMIC_TARIFF_DEFAULT_CHECKED]?: boolean
  [MarketingDataKeys.SETTLEMENT_FREQUENCY_MONTHLY_BY_DEFAULT]?: boolean
}

// PAYLOADS

export type UpdateMarketingDataPayload = {
  key: MarketingDataKeys
  value: BannerTypes | boolean | Product | SignChannel | string | unknown[] | FuelPricelistUrls | AvailableProducts | undefined
}

export type UpdateMarketingStorePayload = {
  marketingStore: MarketingStore
}
